import { OccupationTitlesDto } from "../dto/OccupationTitles";
import { OccupationTypesDto } from "../dto/OccupationTypes";
import { OccupationDirectoryRepository } from "../repositories/OccupationDirectoryRepository";
import type { HttpConfig } from "../helpers/http.config";
import { APIResponse } from "../models/APIResponse";
import { IAuthService } from "./AuthService";
import { BaseAPI } from "../core/BaseAPI";
import { left, right } from "../core/Either";
import { Result } from "../core/Result";
import { toApiError } from "../helpers/api.error";

export class OccupationDirectoryHttp
  extends BaseAPI
  implements OccupationDirectoryRepository
{
  async getTitles(): Promise<APIResponse<OccupationTitlesDto>> {
    try {
      const res = await this.get<OccupationTitlesDto>(
        "/standard-financial-statement/occupation-titles",
      );
      return right(Result.ok<OccupationTitlesDto>(res.data));
    } catch (e) {
      return left(toApiError(e));
    }
  }

  async getTypes(): Promise<APIResponse<OccupationTypesDto>> {
    try {
      const res = await this.get<OccupationTypesDto>(
        "/standard-financial-statement/occupation-types",
      );
      return right(Result.ok<OccupationTypesDto>(res.data));
    } catch (e) {
      return left(toApiError(e));
    }
  }
}

// Optional factory
export const occupationDirectoryHttpRepository = (
  auth: IAuthService,
  cfg: HttpConfig,
) => new OccupationDirectoryHttp(auth, cfg);
